var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkNotUsed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.5 3.09961L17.4375 12.3996L26.35 9.29961L20.15 17.0496L27.9 21.6996L17.825 20.9246L17.05 29.4496L13.95 20.9246L3.875 23.2496L11.625 17.0496L5.425 9.29961L14.3375 12.3996L15.5 3.09961Z",
    fill: "#B4B2A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.4998 7.75L16.6623 13.95L21.6998 12.4L17.8248 17.05L22.4748 20.15L16.2748 19.7625L15.8873 24.8L14.7248 19.7625L9.2998 20.925L13.1748 17.05L9.2998 12.4L14.3373 13.95L15.4998 7.75Z",
    fill: "#D3D1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.4996 18.2121C16.9977 18.2121 18.2121 16.9977 18.2121 15.4996C18.2121 14.0015 16.9977 12.7871 15.4996 12.7871C14.0015 12.7871 12.7871 14.0015 12.7871 15.4996C12.7871 16.9977 14.0015 18.2121 15.4996 18.2121Z",
    fill: "#888780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkNotUsed);
export default __webpack_public_path__ + "static/media/SparkNotUsed.7cc599c797e8fbde78fcde286b54b0f0.svg";
export { ForwardRef as ReactComponent };